import React from 'react';
import { FadeIn } from './FadeIn';
import { ButtonCTA } from './ButtonCTA';
import { Check } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-cream pb-16 sm:pb-24 pt-12 sm:pt-20 overflow-hidden" data-id="element-150">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-152">
          {/* Text Content */}
          <div className="text-center lg:text-left z-10" data-id="element-153">
            <FadeIn delay={0.2} data-id="element-154">
              <span className="inline-flex items-center gap-2 py-2 px-5 rounded-full bg-terracotta text-white text-sm font-bold tracking-wider mb-6 shadow-lg animate-pulse-attention" data-id="element-155">
                <span className="w-2 h-2 rounded-full bg-white animate-ping" data-id="element-156"></span>
                🔥 OFERTA SOLO POR ESTA SEMANA
              </span>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-157">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold text-gray-900 leading-tight mb-6" data-id="element-158">
                Baja de peso sin pasar hambre y sin renunciar a la comida que te
                gusta
              </h1>
            </FadeIn>

            <FadeIn delay={0.6} data-id="element-159">
              <p className="text-lg sm:text-xl text-gray-700 mb-10 font-medium max-w-2xl mx-auto lg:mx-0" data-id="element-160">
                Descubre el método de sustituciones inteligentes con 32 recetas
                fáciles, guía para restaurantes y estrategias para mantener el
                control incluso los fines de semana.
              </p>
            </FadeIn>

            <FadeIn delay={0.8} data-id="element-161">
              <div className="flex flex-col items-center lg:items-start" data-id="element-162">
                <ButtonCTA text="Quiero empezar hoy por $11.99" className="text-lg sm:text-xl px-8 py-5 w-full sm:w-auto mb-6" data-id="element-163" />

                <div className="flex flex-col sm:flex-row items-center gap-4 text-gray-600 font-medium text-sm" data-id="element-164">
                  <div className="flex items-center" data-id="element-165">
                    <Check size={18} className="text-emerald-500 mr-1.5" data-id="element-166" />
                    <span data-id="element-167">Acceso inmediato</span>
                  </div>
                  <div className="hidden sm:block text-gray-300" data-id="element-168">•</div>
                  <div className="flex items-center" data-id="element-169">
                    <Check size={18} className="text-emerald-500 mr-1.5" data-id="element-170" />
                    <span data-id="element-171">Formato PDF</span>
                  </div>
                  <div className="hidden sm:block text-gray-300" data-id="element-172">•</div>
                  <div className="flex items-center" data-id="element-173">
                    <Check size={18} className="text-emerald-500 mr-1.5" data-id="element-174" />
                    <span data-id="element-175">Garantía de 7 días</span>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Visual Mockup */}
          <FadeIn delay={0.6} direction="left" data-id="element-176">
            <div className="relative mx-auto w-full max-w-md lg:max-w-full mt-10 lg:mt-0" data-id="element-177">
              {/* Decorative background blob */}
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-warm-beige/60 rounded-full blur-3xl -z-10" data-id="element-178"></div>

              {/* PDF Book Mockup */}
              <div className="relative transform rotate-3 hover:rotate-0 transition-transform duration-500" data-id="element-179">
                <div className="absolute inset-0 bg-black/10 rounded-2xl transform translate-x-4 translate-y-4 blur-sm" data-id="element-180"></div>
                <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 aspect-[3/4] flex flex-col relative z-10" data-id="element-181">
                  {/* Book Cover Design */}
                  <div className="h-1/2 relative overflow-hidden" data-id="element-182">
                    <img src="https://cdn.magicpatterns.com/uploads/rq7mEJ1E8CWFGf1TmiPtXC/heylloyd-image-1776879825384.png" alt="Personas disfrutando comida saludable" className="w-full h-full object-cover" data-id="element-183" />
                    <div className="absolute inset-0 bg-black/30" data-id="element-184"></div>
                    <h3 className="absolute bottom-4 left-6 right-6 text-3xl sm:text-4xl font-serif font-bold text-white leading-tight z-10 drop-shadow-lg" data-id="element-185">
                      Sabores que
                      <br data-id="element-186" />
                      Adelgazan
                    </h3>
                  </div>
                  <div className="h-1/2 bg-warm-beige p-8 flex flex-col justify-between" data-id="element-187">
                    <p className="text-warm-brown font-medium text-lg" data-id="element-188">
                      El método de sustitución inteligente
                    </p>
                    <div className="flex items-center justify-between mt-auto" data-id="element-189">
                      <div className="flex -space-x-2" data-id="element-190">
                        <div className="w-8 h-8 rounded-full bg-terracotta border-2 border-white" data-id="element-191"></div>
                        <div className="w-8 h-8 rounded-full bg-olive-green-dark border-2 border-white" data-id="element-192"></div>
                        <div className="w-8 h-8 rounded-full bg-warm-brown border-2 border-white" data-id="element-193"></div>
                      </div>
                      <span className="text-sm font-bold text-gray-500" data-id="element-194">
                        32 Recetas
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}